<template>
  <div class="content" :style="'width:100%;height:' + screenHeight + 'px;'">
    <!--topinfo57-->
    <div class="topInfo">
      <div style="margin-top: 12px; margin-bottom: 12px">
        <div class="input">
          <div class="keywordInput">
            <input v-model="keyWord" placeholder="搜索关键词" />
            <img v-if="keyWord" src="../assets/images/images/closeTC.png" class="closeTc" @click="searchAll"/>
          </div>
          <div class="search" @click="searchShopByKeyword">
            <img src="../assets/images/images/search.png" />
          </div>
        </div>
        <div class="area" style="position: absolute; height: 36px; right: 20px">
          <div>
            <div style="border-radius: 5px; overflow: hidden">
              <div
                class="areaDiv"
                v-if="!showAreaList"
                @click="showAddressList"
              >
                <p>{{ nowArea }}</p>
                <img src="../assets/images/images/showMore.png" />
              </div>
              <template v-else>
                <div class="areaDiv" @click="chooseAddres(-1)">
                  <p>全部</p>
                  <img src="../assets/images/images/showMore.png" />
                </div>
                <div>
                  <div
                    class="item"
                    v-for="(item, index) in areaList"
                    :key="index"
                    @click="chooseAddres(index)"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--banner图片98 -->
    <div class="banner" @click="goOther">
      <img :src="banner.thumb_url" />
    </div>
    <!--列表内容-->
    <div class="listContent" :style="`height:${screenHeight - 57 - 98}px;`">
      <!--左侧选择项-->
      <div class="leftlist">
        <div
          :class="categoryID == 0 ? 'active' : 'noActive'"
          @click="chooseCategory(0)"
        >
          全部
        </div>
        <div
          :class="categoryID == item.id ? 'active' : 'noActive'"
          v-for="(item, index) in categoryList"
          :key="index"
          @click="chooseCategory(item.id)"
        >
          {{ item.name }}
        </div>
      </div>
      <!--右侧商家列表内容-->
      <div class="rightList" id="ccc">
        <div class="tipsWord" v-if="showKeyWord">
          以下店铺名称或近期发布的产品中含“{{ keyWord2 }}”关键词
        </div>
        <van-list
          style="margin-bottom: 71px"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="shopInfoList">
            <div
              class="itemInfo"
              v-for="(item, index) in shopInfoList"
              :key="index"
              @click="goShopInfo(item.id)"
            >
              <div>
                <img :src="item.small_logo_url" />
              </div>
              <div class="itemInfoName">
                {{ item.name }}
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <div class="bottomDiv"></div>
    <HomeTab></HomeTab>
    <BackTop></BackTop>
  </div>
</template>
<script>
let me;
import axios from "axios";
import { getData } from "../Interface/http.js";
import BackTop from "../components/BackTop";
import { postData } from "../Interface/http.js";
import HomeTab from "../components/HomeTab2";
export default {
  name: "shopList",
  data() {
    return {
      isShow: false,
      page: 1,
      loading: false,
      finished: false,
      screenHeight: "",
      areaList: [],
      categoryList: [],
      areaID: 0, //区号ID
      nowArea: "全部", //现在的区号
      showAreaList: false, //是否展示区号列表
      categoryID: 0, //查询分类的id，默认全部
      keyWord: "", //用户输入的关键字
      shopInfoList: [], //店铺列表
      banner: {},
      showKeyWord: false,
      keyWord: "",
      keyWord2: "",
    };
  },
  components: {
    HomeTab,
    BackTop,
  },
  methods: {
    searchAll() {
      this.keyWord = '';
      this.searchShopByKeyword();
    },
    onLoad() {
      me.searchShopByAreaAndCategory();
    },
    goOther() {
      window.location.href = me.banner.url;
    },
    searchBannerImg() {
      //查询广告图
      getData("/recommend-lists?position=4&num=1")
        .then((res) => {
          if (res.code == 0) {
            me.banner = res.data[0].banner;
          }
        })
        .catch((err) => {
        });
    },
    goShopInfo(id) {
      me.$router.push({
        name: "shopDetailInfo",
        query: {
          type: "info",
          id: id,
        },
      });
    },
    searchShopByAreaAndCategory() {
      this.loading = true;
      this.finished = false;
      //根据区号和分类查询店铺列表
      getData("/shop/search-area", {
        area_id: me.areaID,
        category_id: me.categoryID,
        page: this.page,
        num: 60
      }).then((res) => {
        this.loading = false;
        if (res.data.length == 0 && me.page == 1) {
          me.shopInfoList = res.data;
        }
        if (res.data.length != 0) {
          if (me.page == 1) {
            me.shopInfoList = res.data;
          } else {
            res.data.map((a) => {
              me.shopInfoList.push(a);
            });
          }
          this.page = this.page + 1;
          //me.searchShopByAreaAndCategory();
        } else {
          this.finished = true;
        }
      });
    },
    searchShopByKeyword() {
      //根据关键字查询店铺
      me.showKeyWord = false;
      me.page = 1;
      if (me.keyWord.length == 1) {
        this.$toast("搜索文字请大于等于两个字");
        return;
      }
      if(me.keyWord.length > 1) {
        me.showKeyWord = true;
      }
      me.categoryID = 0;
      me.nowArea = "全部";
      me.areaID = 0;
      this.loading = true;
      this.finished = false;
      getData("/shop/search", {
        keywords: me.keyWord,
        num: 60,
        page: 1,
      }).then((res) => {
        this.loading = false;
        if (res.code == 0) {
          me.shopInfoList = res.data;
          me.keyWord2 = me.keyWord;
          this.finished = true;
        }
      });
    },
    chooseCategory(id) {
      //选择分类
      me.page = 1;
      me.showKeyWord = false;
      me.keyWord = "";
      me.categoryID = id;
      const query=JSON.parse(JSON.stringify(this.$route.query))
      query.categoryID = id;
      this.$router.push({ path: this.$route.path, query })
      me.getShare();
      me.searchShopByAreaAndCategory();
    },
    chooseAddres(index) {
      //选择地址列表
      me.page = 1;
      me.showKeyWord = false;
      me.keyWord = "";
      if (index == -1) {
        me.nowArea = "全部";
        me.areaID = 0;
      } else {
        me.nowArea = me.areaList[index].name;
        me.areaID = me.areaList[index].id;
      }
      me.searchShopByAreaAndCategory();
      me.showAreaList = false;
    },
    showAddressList() {
      //展开地址列表
      me.showAreaList = true;
    },
    getAreaAndCategory() {
      //获取分类和区号
      getData("/shop/areas").then((res) => {
        me.areaList = res.data.areas;
        me.categoryList = res.data.categories;
      });
    },
    handleScroll() {
      let clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 设备/屏幕高度
      let scrollObj = document.getElementById("ccc"); // 滚动区域
      if(scrollObj) {
        let scrollTop = scrollObj.scrollTop; // div 到头部的距离
        let scrollHeight = scrollObj.scrollHeight; // 滚动条的总高度
        if (scrollTop > 1000) {
          me.isShow = true;
        }
        //滚动条到底部的条件
        if (scrollTop + clientHeight == scrollHeight) {
          // div 到头部的距离 + 屏幕高度 = 可滚动的总高度
        }
      }
      
    },
    getTop() {
      let timer = setInterval(() => {
        let scrollObj = document.getElementById("ccc"); // 滚动区域
        let top = scrollObj.scrollTop; // div 到头部的距离
        let speed = Math.ceil(top / 5);
        document.getElementById("ccc").scrollTop = top - speed;
        document.getElementById("ccc").scrollTop = top - speed;
        if (top === 0) {
          clearInterval(timer);
        }
      }, 20);
    },
    getShare() {
      //获取配置数据
      let pathname = encodeURIComponent(window.location.pathname);
      let search = encodeURIComponent(window.location.search);
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var iPad = u.indexOf("iPad") > -1;
      var iPhone = u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1;
      let anURL =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        window.location.search; //安卓地址
      let iosURL = this.$store.state.jumpUrl; //ios地址
      let result = "";
      if (isAndroid) {
        result = anURL;
      }
      if (isiOS || iPad || iPhone) {
        result = window.location.href;
      }
      //this.message=result;
      result = encodeURIComponent(result);
      getData("/oauth/credential/jssdk?debug=1&url=" + result).then((res) => {
        console.error(me.categoryID)
        wx.config({
          //debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.noncestr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表，所有JS接口列表见微信公众平台附录
        });
        wx.ready(function () {
          wx.updateAppMessageShareData({
            title: '家纺城公众圈', // 分享标题
            desc: '家纺人每天都在用的线上广告平台！', // 分享描述
            link: 'http://jfc.jfbst.com/shopList?active=3&categoryID=' + me.categoryID,
            imgUrl: 'http://cdn11.jfbst.com/statics/pc/share.png', // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              // store.commit("controlStatusUserPage/showMsg", "分享成功");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              // store.commit("controlStatusUserPage/showMsg", "您取消了操作");
            },
          });
          wx.updateTimelineShareData({
            title: '家纺城公众圈', // 分享标题
            link: 'http://jfc.jfbst.com/shopList?active=3&categoryID='+ me.categoryID,
            imgUrl: 'http://cdn11.jfbst.com/statics/pc/share.png', // 分享图标
            success: function (res) {},
            cancel: function () {},
          });
        });
      });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //销毁滚动事件
  },
  created() {

  },
  mounted() {
    me = this;
    me.categoryID = me.$route.query.categoryID; //每个分类都有独立id
    me.getAreaAndCategory();
    me.searchBannerImg();
    me.screenHeight = window.screen.availHeight - (window.screen.availWidth / 375) * 72;
    window.addEventListener("scroll", this.handleScroll);
    me.getShare();
  },
};
</script>
<style scoped>
.bottomDiv {
  width:100%;
  height:71px;
  flex-shrink: 0;
}
.topInfo {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 57px;
  background-color: #892785;
  display: flex;
  justify-content: center;
  align-items: center;
}
.topInfo > div {
  width: 331px;
  height: 36px;
  display: flex;
}
.topInfo > div > div {
  height: 100%;
}
.input {
  width: 226px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  overflow: hidden;
  background-color: #fff;
}
.area {
  color: #8f8f8f;
  font-size: 12px;
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
}

.areaDiv {
  width: 98px;
  background-color: #fff;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.area img {
  margin-left: 3px;
  width: 12.5px;
  height: 12px;
}
.input input {
  width: 95%;
  height: 90%;
  padding: 0;
  border: none;
  padding-left: 5%;
}
.keywordInput {
  display: flex;
  align-items: center;
  width: 177px;
  height: 80%;
  border-right: 1px solid #c1c1c2;
}
.search {
  flex-grow: 1;
  height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.closeTc {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.search img {
  width: 25px;
  height: 25px;
}
/*banner图片*/
.banner {
  width: 100%;
  height: 98px;
  margin-top: 57px;
}
/**列表内容 */
.listContent {
  width: 100%;
  display: flex;
  height: max-content;
}
.content {
  display: flex;
  flex-direction: column;
}
.leftlist {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 100%;
  width: 90px;
  background-color: #fff;
  margin-bottom: 71px;
}
.rightList {
  height: 100%;
  overflow-y: scroll;
}
.noActive {
  width: 99%;
  height: 32px;
  font-size: 14px;
  color: #4d4d4d;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
  border-right: 1px solid #e7e7e7;
}
.active {
  width: 87px;
  height: 32px;
  font-size: 14px;
  color: #9c4d98;
  display: flex;
  background-color: #e6e6e6;
  justify-content: center;
  align-items: center;
  border-left: 2px solid #9c4d98;
  border-bottom: 1px solid #e7e7e7;
  border-right: 1px solid #e7e7e7;
}
.tipsWord {
  width: 100%;
  font-size: 12px;
  color: #892785;
  margin-top: 8px;
}
.shopInfoList {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  width: 285px;
}
.itemInfo {
  color: #666666;
  font-size: 11px;
  text-align: center;
  margin-top: 8px;
  margin-left: 13px;
}
.itemInfo img {
  border: 1px solid #eee;
  border-radius: 10px;
  width: 54.5px;
  height: 54.5px;
}
.itemInfoName {
  width: 55px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item {
  border-top: 1px solid #e7e7e7;
  background-color: #fff;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.slide-fade-enter-active {
  transition: all 0.1s ease;
}
.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.3, 0.8, 1);
  opacity: 0;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(140px);
  opacity: 0;
}
.page-component-up {
  background: #892885;
  position: fixed;
  right: 1rem;
  bottom: 6rem;
  width: 40px;
  height: 40px;
  border-radius: 25px;
  cursor: pointer;
  opacity: 0.5;
  transition: 0.3s;
  text-align: center;
  z-index: 999;
}
.el-icon-caret-top {
  font-size: 36px;
  margin-top: 7px;
  color: #ffffff;
  text-align: center;
  z-index: 1000;
}
.hover {
  background-color: #409eff;
}
</style>